// extracted by mini-css-extract-plugin
module.exports = {"content":"AdvancedForm_content__2aQ-9","link":"AdvancedForm_link__1hs2N"};